import ApiService from './ApiService'

export const getProjectAllWhiteboard = async (id) => {
    try {
        const response = await ApiService.fetchData({
            url: `/whiteboard/projects/all-whiteboard/${id}`,
            method: 'get',
        })
        return response.data;
    } catch (error) {
        return error.message;
    }
}

export const getProjectWhiteboard = async (project_id, data) => {
    try {
        const response = await ApiService.fetchData({
            url: `/whiteboard/projects/${project_id}/whiteboards/${data.whiteboard_id}`,
            method: 'get',
            data: data,
        })
        return response.data;
    } catch (error) {
        return error.message;
    }
}

export const addNewProjectWhiteboard = async (project_id, data) => {

    const response = await ApiService.fetchData({
        url: `/whiteboard/projects/${project_id}/add-whiteboard`,
        method: 'post',
        data: data,
    })

    return response.data;
}

export const addProjectWhiteboard = async (project_id, whiteboard_id, data) => {

    const response = await ApiService.fetchData({
        url: `/whiteboard/projects/${project_id}/whiteboard/edit/${whiteboard_id}`,
        method: 'put',
        data: data,
    })

    return response.data;
}

export const removeProjectWhiteboard = async (project_id, whiteboard_id) => {

    const response = await ApiService.fetchData({
        url: `/whiteboard/projects/${project_id}/whiteboard/delete/${whiteboard_id}`,
        method: 'delete',
    })

    return response.data;
}

export const addWhiteboardComment = async (project_id, whiteboard_id, data) => {

    const response = await ApiService.fetchData({
        url: `/whiteboard/projects/${project_id}/whiteboard/comment/${whiteboard_id}`,
        method: 'post',
        data: data,
    })

    return response.data;
}

export const getWhiteboardComments = async (project_id, whiteboard_id) => {
    try {
        const response = await ApiService.fetchData({
            url: `/whiteboard/projects/${project_id}/whiteboard/comments/${whiteboard_id}`,
            method: 'get',
        })
        return response.data;
    } catch (error) {
        return error.message;
    }
}

export const removeWhiteboardComments = async (project_id, whiteboard_id, data) => {
    try {
        const response = await ApiService.fetchData({
            url: `/whiteboard/projects/${project_id}/whiteboard/delete/comments/${whiteboard_id}`,
            method: 'put',
            data: data,
        })
        return response.data;
    } catch (error) {
        return error.message;
    }
}

export const removeWhiteboardAllComments = async (project_id, whiteboard_id, data) => {
    try {
        const response = await ApiService.fetchData({
            url: `/whiteboard/projects/${project_id}/whiteboard/delete/all/comments/${whiteboard_id}`,
            method: 'put',
            data: data,
        })
        return response.data;
    } catch (error) {
        return error.message;
    }
}

export const editWhiteboardComment = async (project_id, whiteboard_id, data) => {
    try {
        const response = await ApiService.fetchData({
            url: `/whiteboard/projects/${project_id}/whiteboard/edit/comments/${whiteboard_id}`,
            method: 'put',
            data: data,
        })
        return response.data;
    } catch (error) {
        return error.message;
    }
}



